import React, { useRef, useEffect } from 'react';
import * as actions from './actions';
import { contentItemsToShowInCarousel } from './utils';
import { unitySectionService } from '@tbx/experience-widgets-lib';
import { SHOW_ITEMS_BY_DEFAULT } from '../../constants/contentTypes';
import { addDays, endOfDay, startOfDay, subDays } from 'date-fns';

export const fetchComponentData = async ({
  tokenData,
  widgetData,
  state,
  dispatch,
  dispatchRedux,
  authenticated,
  isLoadMoreDataInComponent = false,
  fetchFavoriteContentByProfile,
}) => {
  const { componentItems, orderTypeSelected, prevOrderTypeSelected } = state;
  const { page } = componentItems || {};
  const {
    section: sectionID,
    id: widgetID,
    componentParameters,
    itemsURL,
  } = widgetData || {};
  const { contentListDisplayItems, maxItems, listSource } =
    componentParameters || {};

  const maxItemsToRequest =
    widgetData.componentType === 'epg_grid'
      ? SHOW_ITEMS_BY_DEFAULT.EPG_GRID
      : contentItemsToShowInCarousel(maxItems, contentListDisplayItems);

  let filters = { pageSize: maxItemsToRequest, page: 1 };

  if (isLoadMoreDataInComponent) {
    filters = {
      ...filters,
      page: page?.nextPage,
    };
  }

  if (
    widgetData.componentType === 'gallery_wall' &&
    orderTypeSelected === prevOrderTypeSelected
  ) {
    filters = {
      ...filters,
      orderType: orderTypeSelected,
    };
  }

  if (widgetData.componentType === 'epg_grid') {
    const { daysBefore, daysAfter } = componentParameters;
    const dateFrom = startOfDay(subDays(Date.now(), daysBefore));
    const dateTo = endOfDay(addDays(Date.now(), daysAfter));
    filters = {
      ...filters,
      fromEpg: dateFrom.toISOString(),
      toEpg: dateTo.toISOString(),
    };
  }

  if (
    widgetData.componentType === 'gallery_wall' &&
    orderTypeSelected !== prevOrderTypeSelected
  ) {
    filters = { ...filters, orderType: orderTypeSelected, page: 1 };
    dispatch(actions.setPrevOrderType(orderTypeSelected));
  }
  try {
    const { result } = await unitySectionService.getSectionComponentItems(
      tokenData,
      sectionID,
      widgetID,
      filters,
      itemsURL,
    );

    if (!areEquals(componentItems, result?.result)) {
      if (isLoadMoreDataInComponent) {
        dispatch(actions.loadMoreDataInComponentSuccess(result));
      } else {
        dispatch(actions.loadComponentFetchSuccess(result));
      }

      if (listSource === 'favorites' && authenticated) {
        dispatchRedux(fetchFavoriteContentByProfile(tokenData));
      }
    }
  } catch (e) {
    dispatch(actions.loadComponentFetchFailure(e));
  }
};

/**
 * useHook like hook effect
 *
 * @export
 */

export function useDidMount({
  tokenData,
  widgetData,
  state,
  dispatch,
  dispatchRedux,
  authenticated,
  fetchFavoriteContentByProfile,
}) {
  React.useEffect(() => {
    if (widgetData.id && widgetData.section) {
      fetchComponentData({
        tokenData,
        widgetData,
        state,
        dispatch,
        dispatchRedux,
        authenticated,
        fetchFavoriteContentByProfile,
      });
    }
  }, [state.orderTypeSelected]);
}

/**
 * useRefetchFavorites like hook effect
 *
 * @export
 */

export function useRefetchFavorites({
  tokenData,
  widgetData,
  state,
  dispatch,
  dispatchRedux,
  authenticated,
  favorites,
}) {
  const { componentParameters } = widgetData || {};
  const { listSource } = componentParameters || {};

  useEffect(() => {
    if (listSource !== 'favorites') {
      return;
    }

    fetchComponentData({
      tokenData,
      widgetData,
      state,
      dispatch,
      dispatchRedux,
      authenticated,
    });
  }, [favorites]);
}

/**
 * useInterval like hook effect
 *
 * @export
 */
export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function areEquals(contentCollection, result) {
  if (contentCollection.length !== result.length) {
    return false;
  }
  const resultToContentCollection = result.map((item) => {
    return item.content ? item.content : item;
  });
  if (
    JSON.stringify(resultToContentCollection) ===
    JSON.stringify(contentCollection)
  ) {
    return true;
  }
  return false;
}

export function areEqualsx(contentCollection, result) {
  if (contentCollection.length !== result.length) {
    return false;
  }
  const resultToContentCollection = result.map((item) => {
    return item.content ? item.content : item;
  });
  if (
    JSON.stringify(resultToContentCollection) ===
    JSON.stringify(contentCollection)
  ) {
    return true;
  }
  return false;
}
